module.exports = __webpack_public_path__ + "h5/img/index-outdoorsa.a8f5654e.png";